export default {
  headerTitle: 'ETZ Profile',
};
